import React from "react";
import {Button, Col, CustomInput, Label, Row} from "reactstrap";
import {GroupRequest} from "../../container/broadcast/BroadcastAvailabilityRequests/Components";
import NoRequestReceived from "../NoRequestReceived";
import loading_white from "../../assets/gif/loading_white.gif";
import sessionStyle from "../../container/broadcast/BroadcastAvailabilityRequests/sessionStyle";

const GroupRequests = (props) => {
    const {searchStatus, searchData, requestCount, requests} = props;
    let requestArray = [];

    if (props.hasOwnProperty("initialValues") &&
        props.initialValues.hasOwnProperty("broadcast_type") &&
        props.initialValues.broadcast_type === "paid" &&
        window.location.href.indexOf("private_broadcast_id") === -1) {

        return (
            <NoRequestReceived
                hideShare
                shareList={props.shareList}
                message="You are already in paid session"/>
        )
    }
    if (searchData.length === 0) {
        //nothing searched from the user end so show unfiltered list
        if (requestCount > 0) {
            if (!searchStatus) {
                //there are request pending
                requestArray = requests;
            } else {
                return (
                    <NoRequestReceived
                        hideShare
                        shareList={props.shareList}
                        message="Sorry no results found"/>
                )
            }
        } else {
            //no request pending show empty screen
            return (
                <NoRequestReceived
                    shareList={props.shareList}
                    message="Group requests will appear here. Get sharing and let people know you are available"/>
            )
        }
    } else {
        //user has searched so lets show from the filtered list
        requestArray = searchData;
    }

    if(props.video){
        return(
            <div className="full-width list-of-request">
                {/*Select all*/}
                {requestCount > 0 && (
                    <Row className="mx-0">
                        <Col md="12" sm="12">
                            <Label
                                check
                                className="mb-md-3"
                            >
                                <CustomInput
                                    type="checkbox"
                                    name="selectAllGroup"
                                    id="selectAllGroup"
                                    className="selectAll"
                                    label="SELECT ALL"
                                    checked={
                                        props.selectAllCheckbox === true
                                    }
                                    onClick={props.selectAllToggle}
                                />
                            </Label>
                        </Col>
                    </Row>
                )}
                {/*Select all*/}

                {/*Individual group request*/}
                {
                    requestArray.map(
                        (data, index) =>
                            data.status === 0 && (
                                <GroupRequest
                                    id={data.id}
                                    userName={data.username}
                                    userImage={data.profile_pic}
                                    user_id={data.user_id}
                                    userRequest={
                                        "has requested a group session"
                                    }
                                    userRequestHourAgo={
                                        data.updated_at_human_readable
                                    }
                                    sessionStyle={sessionStyle}
                                    key={index}
                                    status={data.status}
                                    isFavourite={data.is_favourite}
                                    index={index}
                                    selectAllCheckbox={
                                        props.selectAllCheckbox
                                    }
                                    checkboxStore={props.checkboxStore}
                                    checkboxToggle={props.checkboxToggle}
                                    favorite={props.favoriteUserById}
                                    unFavorite={props.unFavoriteUserById}
                                    blockUser={props.blockUserById}
                                    removeRequest={
                                        props.removeUserRequestByReqId
                                    }
                                    video={props.video}
                                />
                            )
                    )
                }
                {/*Individual group request*/}
            </div>
        )
    }

    return (

        <Row className="mx-0 full-width">
            {requestCount > 0 && (
                <Row className="mx-0">
                    <Col md="12" sm="12">
                        <Label
                            check
                            className="mb-md-3 mt-md-1 ml-md-4"
                        >
                            <CustomInput
                                type="checkbox"
                                name="selectAllGroup"
                                id="selectAllGroup"
                                className="selectAll"
                                label="SELECT ALL"
                                checked={
                                    props.selectAllCheckbox === true
                                }
                                onClick={props.selectAllToggle}
                            />
                        </Label>
                    </Col>
                </Row>
            )}
            {
                requestArray.map(
                    (data, index) =>
                        data.status === 0 && (
                            <GroupRequest
                                id={data.id}
                                userName={data.username}
                                userImage={data.profile_pic}
                                user_id={data.user_id}
                                userRequest={
                                    "has requested a Group session"
                                }
                                userRequestHourAgo={
                                    data.updated_at_human_readable
                                }
                                sessionStyle={sessionStyle}
                                key={index}
                                status={data.status}
                                isFavourite={data.is_favourite}
                                index={index}
                                selectAllCheckbox={
                                    props.selectAllCheckbox
                                }
                                checkboxStore={props.checkboxStore}
                                checkboxToggle={props.checkboxToggle}
                                favorite={props.favoriteUserById}
                                unFavorite={props.unFavoriteUserById}
                                blockUser={props.blockUserById}
                                removeRequest={
                                    props.removeUserRequestByReqId
                                }
                            />
                        )
                )
            }
            {
                requestArray.length > 0 &&
                <Row className="mt-5 mb-5 mx-2 full-width">
                    <Col md="12" sm="12" className="text-center">
                        <Button
                            color="primary"
                            {...(props.availability.isFetching
                                ? {style: {padding: "1% 10%"}}
                                : {className: "px-5"})}
                            disabled={
                                props.selectAllCheckbox === true
                                    ? false
                                    : props.checkboxStore.length == 0
                                    ? true
                                    : false
                            }
                            onClick={() =>
                                props.submitBroadcasterAcceptRequest("group")
                            }
                        >
                            {
                                props.availability.isFetching ? (
                                    <img
                                        src={loading_white}
                                        alt={"Loading"}
                                        width={26}
                                        height={26}
                                    />
                                ) : (
                                    "START GROUP SESSION"
                                )}
                        </Button>
                    </Col>
                </Row>
            }
        </Row>
    );
};

export default GroupRequests;